<script lang="ts">
  import { type PlayerInterface } from '@foundation-player/loader';
  import { getContext } from 'svelte';
  import Pause from '../assets/icons/Pause.svelte';
  import Play from '../assets/icons/Play.svelte';
  import type { FocusItem, FocusLayer } from '../focus-manager/focus-types';
  import type { IconButtonSize } from '../types/icon-button';
  import type { PlayerStateContext } from '../types/player-state';
  import IconButton from './IconButton.svelte';

  export let player: PlayerInterface;
  export let size: IconButtonSize = 'm';
  export let focusLayer: FocusLayer;
  export let focusName: FocusItem;

  const { headline, awaitingPlaying, playing } = getContext<PlayerStateContext>('playerState');

  export const togglePlay = () => {
    // Use the current player instead of $playing value to be more robust,
    // except when awaiting playing.
    if (player.isPlaying() || $awaitingPlaying) {
      player.pause();
    } else {
      player.play();
    }
  };

  $: label = $headline && !$playing ? `Wiedergabe von ${$headline} fortsetzen` : undefined;
</script>

<IconButton
  on:click={togglePlay}
  {...$$restProps}
  title={$playing || $awaitingPlaying ? 'Pause' : 'Wiedergabe fortsetzen'}
  aria-label={label}
  {size}
  {focusLayer}
  {focusName}
>
  {#if $awaitingPlaying || $playing}
    <Pause aria-hidden={true} />
  {:else}
    <Play aria-hidden={true} />
  {/if}
</IconButton>
